import React from 'react'
import { HomePage, ProvincesPage, Navbar, ProvinceDetail, WatchListPage, NotFound } from './pages'
import { Route, Switch } from 'react-router-dom'

const App = () => {
  return (
    <>
      <Navbar />
      <Switch>
        <Route exact path="/">
          <HomePage />
        </Route>
        <Route path="/provinces/:province">
          <ProvinceDetail />
        </Route>
        <Route path="/provinces">
          <ProvincesPage />
        </Route>
        <Route exact path="/watchlist">
          <WatchListPage />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </>
  )
}

export default App